var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D26E00",
    d: "M9.806.338 7.49 2.665l2.324 2.338L14.456.338z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F07D00",
    d: "m.521.338 6.968 7 2.325-2.335L7.49 2.665 5.172.338z"
  })));
};
export default SvgLogo;